import { getUtmAndReferrer, SourceInformation } from "@utils/campaign-tracker";
import { isJSXElement } from "@utils/common";
import { leadClassification } from "@utils/leadclassifier";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import { GoCheckCircleFill } from "react-icons/go";

export interface HeroSectionProps {
    title: string;
    listHeading: string | JSX.Element;
    listText: { label: string }[];
    buttonText: string;
    mediaUrl: string;
    altMedia: string;
    ebookName: string;
}

const HeroSection: React.FC<HeroSectionProps> = (props) => {
    const { title, listText, mediaUrl, altMedia, listHeading, ebookName } = props;
    const [campaignDetails, setCampaignDetails] = useState<SourceInformation | undefined>({});

    const { utm_source, utm_medium, utm_campaign, utm_term } = leadClassification(campaignDetails?.lu, campaignDetails?.du, campaignDetails?.ru);

    useEffect(() => {
        setTimeout(() => {
            setCampaignDetails({ ...getUtmAndReferrer() });
        }, 0);
    }, []);

    return (
        <section className="lg:max-w-6xl mx-auto lg:mx-auto lg:px-0 px-4 lg:pt-16 pt-8 flex flex-col gap-11 lg:my-16 my-10">
            <div className="flex lg:flex-row flex-col gap-7">
                <div className="flex flex-col items-center gap-8">
                    <h1 className="md:text-5xl text-2xl font-bold text-gray-900 desktop-line-height">{title}</h1>
                    <Image src={mediaUrl} alt={altMedia} width={585} height={540} />
                    <div className="flex flex-col gap-7">
                        {isJSXElement(listHeading) ? listHeading : <p className="text-gray-700 lg:text-base text-xl font-normal lg:text-left text-left">{listHeading}</p>}
                        <div className="flex flex-col gap-4">
                            {listText.map((text, index) => (
                                <div key={index} className="flex gap-2">
                                    <span className="flex-shrink-0">
                                        <GoCheckCircleFill size="20px" color="blue" />
                                    </span>
                                    <p className="text-base text-gray-700">{text.label}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="md:w-1/2 w-full">
                    <iframe
                        aria-label="Get the eBook"
                        style={{ minWidth: "600px", minHeight: "1120px" }}
                        src={`https://forms.zohopublic.in/gallabox/form/DownloadoureBook/formperma/MHuUtSGAn-4P1UBzTbQHIdihhrlFN2kxxF0woTpQBPM?ebook_name=${ebookName}&utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_terms=${utm_term}`}
                    ></iframe>
                    <style jsx global>{`
                        @media (min-width: 1024px) {
                            .desktop-line-height {
                                line-height: 60px;
                            }
                        }

                        @media (max-width: 600px) {
                            iframe {
                                height: 100vh !important; // Full viewport height on small screens
                                width: 100% !important; // Full width on mobile
                                min-width: 250px !important;
                                min-height: 900px !important;
                            }
                        }
                        @media (min-width: 200px) and (max-width: 600px) {
                            iframe {
                                width: 100% !important; // Full width on mobile
                                min-width: 250px !important;
                                min-height: 1200px !important;
                            }
                        }
                    `}</style>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
